import { animate, animation, query, stagger, state, style, transition, trigger, useAnimation } from '@angular/animations';
import { Component, Input } from '@angular/core';

const fadeIn = animation([
  style({ opacity: 0, transform: 'translateY(10px)' }),
  animate('{{timing}}', style({ opacity: 1, transform: 'translateY(0)' }))
]);

@Component({
  selector: 'app-fab-menu',
  templateUrl: './fab-menu.component.html',
  styleUrls: ['./fab-menu.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(10px)' }),
          stagger('60ms', useAnimation(fadeIn, { params: { timing: '300ms' } }))
        ], { optional: true })
      ])
    ]),
    trigger('spin', [
      state('closed', style({ transform: 'rotate(0)' })),
      state('opened', style({ transform: 'rotate(180deg)' })),
      transition('opened <=> closed', animate('400ms ease-out')),
    ]),
  ]
})
export class FabMenuComponent {
  @Input() options: { text: string; icon: string; action: () => void }[] = [];
  @Input() openIcon: string = 'close'; // Default open icon
  @Input() closeIcon: string = 'more_vert'; // Default close icon
  @Input() closeOnAction: boolean = false; // Close the menu when an option is clicked
  isOpen = false;

  toggleOptions() {
    this.isOpen = !this.isOpen;
  }

  optionClicked(option: { text: string; icon: string; action: () => void }) {
    option.action();
    if (this.closeOnAction) {
      this.toggleOptions(); //Optionally close the menu on option click
    }
  }
}
